import produce from 'immer';
import * as Actions from 'src/actions/types';
import * as AccountActions from 'src/actions/accountActions';
import * as Entities from 'src/config/Entities';

const initialState = {
  navigation: {
    tab: 'details'
  },
  organization: null,
  organizations: null,
  pageinfo: null,
  fetching: false,
  mode: Entities.EntityMode.view
};

const myorganizationReducer = (state = initialState, action) => {
  switch (action.type) {
    // NAVIGATION
    case Actions.ME_ORG_NAVIGATION_SET: {
      const { navigation } = action.payload;
      return produce(state, draft => {
        const newNav = {
          ...state.navigation,
          ...navigation
        };
        draft.navigation = newNav;
      });
    }

    // LIST
    case Actions.ME_ORG_LIST_REQUEST: {
      return produce(state, draft => {
        draft.fetching = true;
      });
    }
    case Actions.ME_ORG_LIST_RECEIVE: {
      const { entities, pageinfo } = action.payload;
      return produce(state, draft => {
        draft.pageinfo = pageinfo;
        draft.organizations = entities;
        draft.fetching = false;
      });
    }

    // ENTITY
    case Actions.ME_ORG_MODE: {
      const { mode } = action.payload;
      return produce(state, draft => {
        draft.mode = mode;
      });
    }
    case Actions.ME_ORG_REQUEST: {
      return produce(state, draft => {
        draft.fetching = true;
      });
    }
    case Actions.ME_ORG_RECEIVE:
    case Actions.ME_ORG_UPDATE: {
      const { entity } = action.payload;
      return produce(state, draft => {
        draft.organization = entity;
        draft.fetching = false;
      });
    }
    case Actions.ME_ORG_FINISHED: {
      return produce(state, draft => {
        draft.fetching = false;
      });
    }

    //------------------------------
    // From Account
    //------------------------------

    case AccountActions.LOGOUT:
    case AccountActions.LOGIN_REQUEST: {
      return produce(state, draft => {
        // Ensure we clear current session
        draft.organization = null;
        draft.organizations = null;
        draft.pageinfo = null;
        draft.fetching = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default myorganizationReducer;
